import React from 'react'
import Akzonobel from '../../images/partners_logos/Akzonobel.png'
import Amiad from '../../images/partners_logos/Amiad-small.png'
import Arkema from '../../images/partners_logos/Arkema.png'
import Basf from '../../images/partners_logos/BASF.png'
import Brentag from '../../images/partners_logos/Brentag.png'
import Coatex from '../../images/partners_logos/Coatex.png'
import Dow from '../../images/partners_logos/Dow.png'
import Grundfos from '../../images/partners_logos/Grundfos.png'
import Huntsman from '../../images/partners_logos/Huntsman.png'
import ItalmatchChemicals from '../../images/partners_logos/Italmatch-chemicals.png'
import LONZA from '../../images/partners_logos/Lonza.png'
import Margunas from '../../images/partners_logos/Margunas.png'
import Prominent from '../../images/partners_logos/Prominent.png'
import Purolite from '../../images/partners_logos/Purolite.png'

const Partners = () => (
  <div className="partners">
    <img className="partners-item" src={Akzonobel} alt="Akzonobel" />
    <img className="partners-item" src={Amiad} alt="Amiad" />
    <img className="partners-item" src={Arkema} alt="Arkema" />
    <img className="partners-item" src={Basf} alt="Basf" />
    <img className="partners-item" src={Brentag} alt="Brentag" />
    <img className="partners-item" src={Coatex} alt="Coatex" />
    <img className="partners-item" src={Dow} alt="Dow" />
    <img className="partners-item" src={Grundfos} alt="Grundfos" />
    <img className="partners-item" src={Huntsman} alt="Huntsman" />
    <img
      className="partners-item"
      src={ItalmatchChemicals}
      alt="Italmatch Chemicals"
    />
    <img className="partners-item" src={LONZA} alt="Lonza" />
    <img className="partners-item" src={Margunas} alt="Margunas" />
    <img className="partners-item" src={Prominent} alt="ProMinent" />
    <img className="partners-item" src={Purolite} alt="Purolite" />
  </div>
)

export default Partners
